var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-confirmation-sent-page"},[_c('header-pane',{attrs:{"pageTitle":_vm.$tc('SignupPage.pageTitle'),"colorType":"light"}}),_c('app-confirmation-sent-pane',{attrs:{"appSignUpFlowType":_vm.appSignUpFlowType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }